import { makeStyles } from '@material-ui/core/styles'

export default makeStyles({
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flex: 1,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    overflow: 'overlay'
  },
  contentScroll: {
    display: 'flex',
    justifyContent: 'center',
    flex: 1,
    minHeight: '100%',
    zIndex: 5
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    height: '100%',
    padding: 30
  },
  logo: {
    marginBottom: 20
  },
  copyright: {
    marginTop: 100
  }
})
